@if (profileField$ | async; as profileField) {
  @if (profileField.DisplayLabel) {
    <ng-container *ngTemplateOutlet="valueTitle"></ng-container>
  }
  @for (childProfileField of childProfileFields$ | async; track childProfileField) {
    @if (childProfileField?.FieldDefinition) {
      <sh-generic-readonly-field
        [style]="nestedPadding$ | async"
        [profileField]="childProfileField"
        [record]="record$ | async"
        [nestedIndex]="(nestedIndex$ | async)! + 1"
        >
      </sh-generic-readonly-field>
    } @else {
      <dt class="sh-description-list__term">{{ profileField.DisplayLabel }}</dt>
      <dd class="sh-description-list__details">{{ "form.error.fielddefinition-not-found" | translate: { id: profileField.FieldDefinitionId } }}</dd>
    }
  }
  <dt class="sh-description-list__term"></dt>
  <dd class="sh-description-list__details sh-complex-spacer"></dd>
  <ng-template #valueTitle let-index="index">
    <dt [id]="profileField.FieldDefinition.FlatKey" class="sh-description-list__term sh-complex-title" [style]="nestedPadding$ | async">
      <b>{{ profileField.DisplayLabel }} {{ index ? index + 1 : "" }} {{ nestedIndex }}</b>
    </dt>
    <dd class="sh-description-list__details"></dd>
  </ng-template>
}
